import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { createApiClient } from '../../api/client';
import '../mobile.css';

const normalizeIndianMobile = (raw) => {
  let s = String(raw || '').trim().replace(/\D/g, '');
  if (s.startsWith('91') && s.length > 10) s = s.slice(2);
  if (s.startsWith('0') && s.length > 10) s = s.slice(1);
  if (s.length > 10) s = s.slice(-10);
  return s;
};

const isValidIndianMobile = (raw) => /^[6-9]\d{9}$/.test(normalizeIndianMobile(raw));

const MobileShareCase = ({ API_URL }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const fir = location.state?.fir;

  const [mobile, setMobile] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  if (!fir) {
    return <p style={{ textAlign: 'center', fontWeight: 700 }}>No case selected to share.</p>;
  }

  const handleShare = async () => {
    if (!isValidIndianMobile(mobile)) {
      setErrorMessage('Please enter a valid Indian mobile number.');
      return;
    }

    setLoading(true);
    setErrorMessage('');

    try {
      const api = createApiClient(API_URL);
      await api.post(`/fir/share/${fir.id}`, { email: normalizeIndianMobile(mobile) });
      setSuccessMessage(`Case shared successfully with ${mobile}`);
    } catch (err) {
      setErrorMessage(err?.response?.status === 401 ? 'You are not authorised to share this case.' : 'An error occurred. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2 style={{ fontSize: '20px', fontWeight: 700, marginBottom: '15px', color: '#094268' }}>Share Case</h2>
      <p style={{ marginBottom: '15px' }}>Share {fir.complainant?.name || 'this case'}'s case with another LegalApp user by their registered mobile number.</p>

      <input
        placeholder="Recipient's Mobile Number"
        value={mobile}
        inputMode="numeric"
        onChange={(e) => setMobile((e.target.value || '').replace(/\D/g, '').slice(0, 10))}
        style={{ width: '100%', boxSizing: 'border-box', borderWidth: 1, borderStyle: 'solid', borderColor: '#ccc', borderRadius: '8px', padding: '12px', marginBottom: '12px' }}
      />

      <button onClick={handleShare} disabled={loading || !mobile} className="m-button-primary">
        {loading ? <div className="m-spinner" style={{ margin: '0 auto' }} /> : 'Share'}
      </button>

      {errorMessage && (
        <div className="m-popup-overlay">
          <div className="m-popup-container">
            <h3>Error</h3>
            <p>{errorMessage}</p>
            <button className="m-button-primary" onClick={() => setErrorMessage('')}>OK</button>
          </div>
        </div>
      )}

      {successMessage && (
        <div className="m-popup-overlay">
          <div className="m-popup-container">
            <h3>Success</h3>
            <p>{successMessage}</p>
            <button className="m-button-primary" onClick={() => navigate('/m/cases')}>OK</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileShareCase;
